// Convert a "HH:MM" 24-hour time string to a friendly 12-hour label, e.g.
// "13:30" → "1:30 PM", "09:00" → "9:00 AM", "00:15" → "12:15 AM".
// Returns the input unchanged if it isn't a parseable HH:MM value.
export function to12h(hhmm) {
  if (!hhmm || typeof hhmm !== "string") return hhmm || "";
  const m = hhmm.trim().match(/^(\d{1,2}):(\d{2})/);
  if (!m) return hhmm;
  let h = parseInt(m[1], 10);
  const min = m[2];
  if (!Number.isFinite(h)) return hhmm;
  const suffix = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${min} ${suffix}`;
}
